import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import '../style.css';

class ViewModal extends React.Component {
  render() {
    return (
      <Modal {...this.props} bsSize="large">
        <Modal.Header className="modal-header-primary">
          <Modal.Title id="contained-modal-title-lg">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.props.onHide}
            >
              <i className="fa fa-close"> </i>
            </button>

            {this.props.titlemodal}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group input-modal col-md-12">
            <div className="label-modal">
              <label>
                Course Title<span className="modal-star">*</span>
              </label>
            </div>
            <div className="feild-modal">
              <input
                type="Course Title"
                className="form-control"
                name="Course_title"
                onChange={(e) => this.props.handleTitleChange(e.target.value)}
                value={this.props.coursetitle}
              />
            </div>
          </div>
          <div className="form-group input-modal col-md-12">
            <div className="label-modal">
              <label>
                Course Description<span className="modal-star">*</span>
              </label>
            </div>
            <div className="feild-modal">
              <textarea
                onChange={(e) => this.props.handleDescChange(e.target.value)}
                value={this.props.coursedesc}
                className="form-control"
                id="Course Description"
                rows="3"
              ></textarea>
            </div>
          </div>
          <div className="form-group input-modal col-md-12">
            <div className="label-modal">
              <label>
                Course Location<span className="modal-star">*</span>
              </label>
            </div>
            <div className="feild-modal">
              <select
                value={this.props.courselocation}
                className="form-control"
                id="sel1"
                onChange={(e) => this.props.handleLocChange(e.target.value)}
              >
                <option value="" disabled hidden></option>
                {this?.props?.course_Location?.length &&
                  this?.props?.course_Location?.map((item, index) => {
                    return (
                      <option key={index} value={item.ID}>
                        {item.Name}
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>
          <div className="form-group input-modal col-md-12">
            <div className="label-modal">
              <label>
                Course Venue<span className="modal-star">*</span>
              </label>
            </div>
            <div className="feild-modal">
              <input
                type="Course Venue"
                className="form-control"
                id="Course Venue"
                onChange={(e) => this.props.handleVenueChange(e.target.value)}
                value={this.props.coursevenue}
              />
            </div>
          </div>
          <div className="form-group input-modal col-md-12">
            <div className="label-modal">
              <label>
                Course Type<span className="modal-star">*</span>
              </label>
            </div>
            <div className="feild-modal">
              <select
                value={this.props.coursetype}
                className="form-control"
                id="sel1"
                onChange={(e) => this.props.handleTypeChange(e.target.value)}
              >
                <option value="" disabled hidden></option>
                {this?.props?.cpd_Handle_Type?.length &&
                  this?.props?.cpd_Handle_Type?.map((item, index) => {
                    return (
                      <option key={index} value={item.CPDTypeId}>
                        {item.Description}
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>
          <div className="form-group input-modal col-md-12">
            <div className="label-modal">
              <label>
                Format<span className="modal-star">*</span>
              </label>
            </div>
            <div className="feild-modal">
              <select
                value={this.props.courseformat}
                className="form-control"
                id="sel1"
                onChange={(e) => this.props.handleFormatChange(e.target.value)}
              >
                <option value="" disabled hidden></option>
                {this?.props?.cpd_format?.length &&
                  this?.props?.cpd_format?.map((item, index) => {
                    return (
                      <option key={index} value={item.ID}>
                        {item.Name}
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>
          <div
            className="form-group input-modal col-md-12
            "
          >
            <div className="label-modal">
              <label>
                Host<span className="modal-star">*</span>
              </label>
            </div>

            <div className="feild-modal">
              <select
                value={this.props.coursehost}
                className="form-control"
                id="sel1"
                onChange={(e) => this.props.handleHostChange(e.target.value)}
              >
                <option value="" disabled hidden></option>
                {this?.props?.host?.length &&
                  this?.props?.host?.map((item, index) => {
                    return (
                      <option key={index} value={item?.ID}>
                        {item?.Name}
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>
          <div className="form-group input-modal col-md-12">
            <div className="label-modal">
              <label>Trainer</label>
            </div>
            <div className="feild-modal">
              <input
                type="Trainer"
                className="form-control"
                id="Trainer"
                onChange={(e) => this.props.handleTrainerChange(e.target.value)}
                value={this.props.coursetrainer}
              />
            </div>
          </div>{' '}
          <div className="form-group input-modal col-md-12">
            <div className="label-modal">
              <label>Start Date</label>
            </div>
            <div className="feild-modal">
              <input
                type="date"
                className="form-control"
                id="Start Date"
                onChange={(e) =>
                  this.props.handleStartDateChange(e.target.value)
                }
                value={this?.props?.coursestartdate?.split('T')[0]}
              />
            </div>
          </div>{' '}
          <div className="form-group input-modal col-md-12">
            <div className="label-modal">
              <label>
                CPD Hours<span className="modal-star">*</span>
              </label>
            </div>
            <div className="feild-modal-cpdHour">
              <input
                type="number"
                className="form-control"
                id="CPD Hours"
                placeholder="Hours"
                onChange={(e) => this.props.handleCpdHourChange(e.target.value)}
                value={this.props.coursecpdhour}
              />
              <input
                type="number"
                className="form-control"
                placeholder="Minutes"
                id="CPD Hours"
                onChange={(e) =>
                  this.props.handleCpdMinutesChange(e.target.value)
                }
                value={this.props.coursemin}
              />
            </div>
          </div>
          <div className="form-group input-modal col-md-12">
            <div className="label-modal">
              <label>How To Book</label>
            </div>
            <div className="feild-modal">
              <textarea
                onChange={(e) =>
                  this.props.handleCourseBookChange(e.target.value)
                }
                value={this.props.coursebook}
                className="form-control"
                name=""
                id=""
                rows="3"
              ></textarea>
            </div>
          </div>
          <div className="form-group input-modal col-md-12">
            <div className="label-modal">
              <label>SurveyLink</label>
            </div>
            <div className="feild-modal">
              <input
                type="SurveyLink"
                className="form-control"
                id="SurveyLink"
                onChange={(e) =>
                  this.props.handleSurveyLinkChange(e.target.value)
                }
                value={this.props.coursesurveylink}
              />
            </div>
          </div>
          {this.props.addeditcoursebtn === true ? (
            <>
              <div className="form-group col-md-12 input-modal">
                <label>Document to Upload</label>
                <div className="button-upload">
                  <div className="col-md-6">
                    <input
                      type="file"
                      className="input-file"
                      onChange={(e) =>
                        this.props?.file(
                          e.target.files?.length && e.target.files[0]
                        )
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <button
                      type="button"
                      className="btn btn-primary start"
                      onClick={this.props.handleuploadfile}
                    >
                      <i className="glyphicon glyphicon-upload"></i>
                      <span>Start upload</span>
                    </button>
                  </div>
                </div>
              </div>

              <div className="input-modal col-md-12">
                <div className="col-table">
                  <table className="table table-striped table-bordered table-hover table-condensed">
                    <thead>
                      <tr className="header">
                        <th>Document</th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.filesData?.length
                        ? this.props.filesData?.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item.FileName}</td>
                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() =>
                                      this.props.handleDeleteFile(
                                        item.ID,
                                        item.CourseId
                                      )
                                    }
                                  >
                                    Delete
                                  </button>
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() =>
                                      this.props.handleDownloadFile(item.ID)
                                    }
                                  >
                                    Download
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        : null}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          ) : null}
          <div className="form-group input-modal col-md-12">
            <div className="admin-only">
              <label>Admin Only</label>{' '}
              <input
                checked={this?.props?.adminActive}
                type="checkbox"
                onChange={(e) => this.props.listViewAdminOnly(e.target.checked)}
              />
            </div>
            <div className="house-only">
              <label>In-House Only</label>{' '}
              <input
                type="checkbox"
                checked={this.props.inHouse}
                onChange={(e) =>
                  this.props.listViewInHouseOnly(e.target.checked)
                }
              />
            </div>
          </div>
          {this.props.inHouse === true ? (
            <div className="form-group input-modal col-md-12">
              <div className="label-modal">
                <label>Employer Detail</label>
              </div>
              <div className="feild-modal">
                <input
                  type="Course Venue"
                  className="form-control"
                  id="Course Venue"
                  // onChange={(e) => this.props.handleVenueChange(e.target.value)}
                  // value={this.props.coursevenue}
                />
              </div>
            </div>
          ) : null}
          <div className="form-group input-modal col-md-12">
            <div className="admin-only">
              <label>Payment Needed</label>{' '}
              <input
                checked={this?.props?.paymentneeded}
                type="checkbox"
                onChange={(e) =>
                  this.props.handlePaymentNeededChange(e.target.checked)
                }
              />
            </div>
          </div>
          <div className="input-modal col-md-12">
            <div className="label-modal">
              <label>Archive</label>
            </div>
            <div className="feild-modal">
              <label className="switch">
                <input
                  type="checkbox"
                  onChange={(e) => this.props.handleSwitchButton(e)}
                  checked={this.props.switchCheck}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {this.props.addeditcoursebtn === false ? (
            <Button
              className="btn btn-primary"
              onClick={this.props.handleAddData}
            >
              Add
            </Button>
          ) : (
            <Button
              className="btn btn-primary"
              onClick={this.props.handleUpdateData}
            >
              Submit
            </Button>
          )}

          <Button className="btn btn-warning" onClick={this.props.onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ViewModal;
